function setSortValue() {
  const sortDropdown = document.getElementById('sort-dropdown');
  const queryParam = 'search[s]';

  sortDropdown.querySelector('.title').addEventListener('click', () => {
    sortDropdown.classList.toggle('active');
  });

  const query = (new URLSearchParams(window.location.search)).get(queryParam);
  if (query === null) { return; }

  const items = sortDropdown.querySelectorAll('.items .item');
  for (let i = 0, len = items.length; i < len; i += 1) {
    const item = items[i];
    if (query === (new URLSearchParams(item.href.split('?')[1])).get(queryParam)) {
      item.classList.add('active');
      return;
    }
  }
}

export default setSortValue;
